export const getSportConfig = (event, isMiniEventCard, cardConfig) => {
    return {
        id: event.sportId,
        config: cardConfig
    };
};
//# sourceMappingURL=getSportConfig.js.map